export default __webpack_public_path__ + "static/1852-a523457e7bb0a093007b0e48e59ecb4b.gif";